export default "__VITE_ASSET__DNyHZB3s__"